module.exports = __webpack_public_path__ + "static/media/sad.619142b2.png";